import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { Cin7ListResponse, Cin7SaleSummary } from "@/api/dtos";
import type { SaleSummary } from "./_models/Sale";
import { toSaleSummaryFromCin7SaleSummary } from "./_transformers/toSaleSummaryFromCin7SaleSummary";

type SaleListResponse = Cin7ListResponse<"SaleList", Cin7SaleSummary>;

const PAGE_LIMIT = 500;

/** Cin7 sales, first page of saleList in Cin7's default order (via the backend Cin7 proxy). */
export const getSaleListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSaleList: builder.query<SaleSummary[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<SaleListResponse>(
            `${backendBase()}/cin7/sale-list`,
            {
              params: { Page: 1, Limit: PAGE_LIMIT },
              headers: { Accept: "application/json" },
            },
          );
          const sales = res.data.SaleList.map((x) => toSaleSummaryFromCin7SaleSummary(x));
          return { data: sales };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
    }),
  }),
});

export const getSaleList = getSaleListApi.endpoints.getSaleList;
